import React from "react";

// Checkbox mark — the to-do item finally checked off. Legible at 24px.
export function CheckMark({ size = 28, className = "", accent = "#0F6E56", box = "#2B2A28" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      className={className}
      aria-hidden="true"
    >
      <rect x="1.5" y="1.5" width="29" height="29" rx="7" stroke={box} strokeWidth="2.4" />
      <path
        d="M9 16.5l4.2 4.2L23 11"
        fill="none"
        stroke={accent}
        strokeWidth="3.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function Wordmark({ light = false, iconSize = 26, className = "" }) {
  const textColor = light ? "#FAF6F0" : "#2B2A28";
  return (
    <span className={`inline-flex items-center gap-2 select-none ${className}`}>
      <CheckMark size={iconSize} box={light ? "#FAF6F0" : "#2B2A28"} accent="#0F6E56" />
      <span
        className="font-display font-extrabold lowercase tracking-tight leading-none"
        style={{ color: textColor, fontSize: iconSize * 0.72 }}
      >
        he meant to
      </span>
    </span>
  );
}
